import { render, staticRenderFns } from "./courseTeacherHome.vue?vue&type=template&id=06c95a9f&scoped=true&"
import script from "./courseTeacherHome.vue?vue&type=script&lang=js&"
export * from "./courseTeacherHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c95a9f",
  null
  
)

export default component.exports